export const TERMS_OF_USE_URL = 'https://expensewatcher.com/terms-of-use/';
export const PRIVACY_POLICY_URL = 'https://expensewatcher.com/privacy-policy/';
